<template>
  <div class="leader-container">
    <div class="center-container">
      <p class="section-title-line">
        <span>新希望地产领导班子</span>
      </p>

      <div
        class="section-container"
        data-wow-duration="500ms"
      >
        <el-row :gutter="15">
          <el-col :span="8">
            <div class="boss-img-wrap">
              <img
                class="boss-img"
                src="../../../assets/images/leaders/1.jpg"
                alt=""
              />
            </div>
          </el-col>
          <el-col :span="8">
            <div class="special-col">
              <p class="boss-name">姜孟军</p>
              <p class="boss-info">新希望地产 总裁</p>
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="15">
          <el-col :span="8">
            <div class="boss-img-wrap boss-item">
              <img
                class="boss-img"
                src="../../../assets/images/leaders/2.jpg"
                alt=""
              />
            </div>
            <p class="boss-name">武敏</p>
            <p class="boss-info">新希望地产 常务副总裁</p>
            <p class="boss-info">&nbsp;</p>
          </el-col>
          <!-- <el-col :span="8">
            <div class="boss-img-wrap boss-item">
              <img
                class="boss-img"
                src="../../../assets/images/leaders/3.jpg"
                alt=""
              />
            </div>
            <p class="boss-name">董李</p>
            <p class="boss-info">新希望地产 副总裁</p>
            <p class="boss-info">新希望文旅 总裁</p>
          </el-col> -->
          <el-col :span="8">
            <div class="boss-img-wrap boss-item">
              <img
                class="boss-img"
                src="../../../assets/images/leaders/4.jpg"
                alt=""
              />
            </div>
            <p class="boss-name">樊俊宏</p>
            <p class="boss-info">新希望地产 副总裁</p>
            <p class="boss-info">&nbsp;</p>
          </el-col>
          <el-col :span="8">
            <div class="boss-img-wrap boss-item">
              <img
                class="boss-img"
                src="../../../assets/images/leaders/5.jpg"
                alt=""
              />
            </div>
            <p class="boss-name">宋延安</p>
            <p class="boss-info">新希望地产 副总裁</p>
            <p class="boss-info">&nbsp;</p>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "LeaderPage",
  data() {
    return {};
  },
  mounted() {
    this.$nextTick(() => {
      this.$wow.init();
    });
  },
};
</script>
<style lang="scss" scoped>
.leader-container {
  .boss-img-wrap {
    width: 100%;
    overflow: hidden;
  }
  .boss-img {
    display: block;
    max-width: 100%;
    height: auto;
    width: 100%;
    transition: all 0.4s linear;
  }

  .boss-item {
    margin-top: 30px;
  }

  .boss-name {
    line-height: 35px;
    font-size: 26px;
    color: #565c61;
    font-weight: 400;
    margin-top: 30px;
    margin-bottom: 22px;
  }

  .boss-info {
    font-size: 16px;
    font-weight: 400;
    color: #565c61;
    line-height: 20px;
  }

  .special-col {
    box-sizing: border-box;
    padding: 46px 145px 0 80px;
  }
}
</style>
